
const UserService = () => import(/* webpackChunkName: "user" */ '@/pages/user/Service');
const UserBindCreate = () => import(/* webpackChunkName: "user" */ '@/pages/user/bind/Create');
const UserBindIndex = () => import(/* webpackChunkName: "user" */ '@/pages/user/bind/Index');
const UserBindReset = () => import(/* webpackChunkName: "user" */ '@/pages/user/bind/Reset');
const UserBindRebind = () => import(/* webpackChunkName: "user" */ '@/pages/user/bind/Rebind');
const UserMember = () => import(/* webpackChunkName: "user" */ '@/pages/user/member/Index');
const UserMemberView = () => import(/* webpackChunkName: "user" */ '@/pages/user/member/View');
const UserAddressIndex = () => import(/* webpackChunkName: "user" */ '@/pages/user/address/Index');
const UserAddressView = () => import(/* webpackChunkName: "user" */ '@/pages/user/address/View');
const UserAddressCreate = () => import(/* webpackChunkName: "user" */ '@/pages/user/address/Create');
const UserEduIndex = () => import(/* webpackChunkName: "user" */ '@/pages/user/edu/Index');
const UserEduView = () => import(/* webpackChunkName: "user" */ '@/pages/user/edu/View');
const UserEduCreate = () => import(/* webpackChunkName: "user" */ '@/pages/user/edu/Create');
const UserOrderIndex = () => import(/* webpackChunkName: "user" */ '@/pages/user/order/Index');
const UserOrderView = () => import(/* webpackChunkName: "user" */ '@/pages/user/order/View');
const UserOrderWord = () => import(/* webpackChunkName: "user" */ '@/pages/user/order/Word');
const UserOrderExpress = () => import(/* webpackChunkName: "user" */ '@/pages/user/order/Express');

export default function (router) {
    // 路由配置
    router.addRoutes([
        { 
            path: "/user/service", 
            component: UserService,
            meta: {
                title: '我的足迹',
                dialog: true,
            }
        },
        {
            path: "/user/bind",
            component: UserBindIndex,
            meta: {
                title: '绑定手机',
                dialog: true
            }
        },
        {
            path: "/user/bind/create",
            component: UserBindCreate,
            meta: {
                title: '绑定手机',
                dialog: true
            }
        },
        {
            path: "/user/bind/reset",
            component: UserBindReset,
            meta: {
                title: '重置密码',
                dialog: true,
            }
        },
        {
            path: "/user/bind/rebind",
            component: UserBindRebind,
            meta: {
                title: '更换手机号',
                dialog: true,
            }
        },
        { 
            path: '/user/member', 
            component: UserMember,
            meta: {
                title: '会员注册',
                dialog: true
            }
        },
        { 
            path: '/user/member/:id', 
            component: UserMemberView,
            meta: {
                title: '会员详情',
                dialog: true,
            }
        },
        { 
            path: '/user/order', 
            component: UserOrderIndex,
            meta: {
                title: '我的订单',
                dialog: true,
            }
        },
        { 
            path: '/user/order/:id', 
            component: UserOrderView,
            meta: {
                title: '订单详情',
                dialog: true
            }
        },
        { 
            path: '/user/order/:id/word', 
            component: UserOrderWord,
            meta: {
                title: '设置签名',
                dialog: true
            }
        },
        { 
            path: '/user/order/:id/express', 
            component: UserOrderExpress,
            meta: {
                title: '物流跟踪',
                dialog: true
            }
        },
        { 
            path: '/user/address', 
            component: UserAddressIndex,
            meta: {
                title: '地址本',
                dialog: true,
            }
        },
        { 
            path: '/user/address/create', 
            component: UserAddressCreate,
            meta: {
                title: '新地址',
                dialog: true,
            }
        },
        { 
            path: '/user/address/:id', 
            component: UserAddressView,
            meta: {
                title: '修改地址',
                dialog: true,
            }
        },
        { 
            path: '/user/edu', 
            component: UserEduIndex,
            meta: {
                title: '教育信息',
                dialog: true,
            }
        },
        { 
            path: '/user/edu/create', 
            component: UserEduCreate,
            meta: {
                title: '新信息',
                dialog: true,
            }
        },
        { 
            path: '/user/edu/:id', 
            component: UserEduView,
            meta: {
                title: '修改教育信息',
                dialog: true,
            }
        },
    ]);
}